/* src/app/modules/expense/advancepayment/advancePayment.component.css */
.example-icon {
  padding: 0 14px;
}
.toolbar-spacer {
  flex: 1 1 auto;
}
.index-row {
  flex: 5;
}
.index-button {
  flex: 1;
}
table thead tr {
  background: #e3fd64;
}
tfoot {
  background-color: #343a40;
  color: white;
}
.ap-page {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background: var(--cf-bg, #f4f6f8);
  font-family: "Inter Tight", sans-serif;
}
.ap-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 24px;
  background: var(--cf-surface, #fff);
  border-bottom: 1px solid var(--cf-border, #e5e7eb);
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  flex-wrap: wrap;
}
.ap-header__icon {
  width: 42px;
  height: 42px;
  border-radius: 11px;
  background: rgba(227, 253, 100, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.ap-header__icon mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: var(--cf-brand-dark);
}
.ap-header__title {
  margin: 0 0 2px;
  font-size: 1rem;
  font-weight: 700;
  color: var(--cf-text, #1a1d23);
  line-height: 1.3;
}
.ap-header__sub {
  margin: 0;
  font-size: 0.78rem;
  color: var(--cf-text-muted, #6b7280);
}
.ap-header__summary {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 16px;
  background: var(--cf-bg, #f4f6f8);
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: var(--cf-radius, 8px);
  padding: 8px 16px;
}
.ap-header__summary-divider {
  width: 1px;
  height: 28px;
  background: var(--cf-border, #e5e7eb);
}
.ap-header__summary-item {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.ap-header__summary-label {
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--cf-text-muted, #6b7280);
}
.ap-header__summary-value {
  font-size: 0.925rem;
  font-weight: 600;
  color: var(--cf-text, #1a1d23);
  font-variant-numeric: tabular-nums;
}
.ap-header__summary-value--total {
  font-size: 1.05rem;
  color: var(--cf-brand-dark, #4d7a00);
}
.ap-btn-save {
  background: var(--cf-brand, #e3fd64) !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(227, 253, 100, 0.25) !important;
  white-space: nowrap;
}
.ap-btn-save:hover:not([disabled]) {
  background: var(--cf-brand-dark, #4d7a00) !important;
}
.ap-body {
  padding: 14px 20px;
  flex: 1;
}
.ap-grid {
  display: grid;
  grid-template-columns: 1fr 1.4fr;
  gap: 16px;
  align-items: start;
}
@media (max-width: 960px) {
  .ap-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 768px) {
  .ap-body {
    padding: 10px 12px;
  }
  .ap-header {
    padding: 10px 14px;
  }
}
.ap-section {
  background: var(--cf-surface, #fff);
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: var(--cf-radius-lg, 12px);
  overflow: hidden;
  box-shadow: var(--cf-shadow-sm, 0 1px 3px rgba(0,0,0,0.08));
  margin-bottom: 10px;
}
.ap-section:last-child {
  margin-bottom: 0;
}
.ap-section__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: var(--cf-bg, #f4f6f8);
  border-bottom: 1px solid var(--cf-border, #e5e7eb);
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--cf-text, #1a1d23);
}
.ap-section__head mat-icon {
  font-size: 15px;
  width: 15px;
  height: 15px;
  color: var(--cf-brand, #e3fd64);
  flex-shrink: 0;
}
.ap-section__head-help {
  margin-left: auto;
}
.ap-section__body {
  padding: 10px 14px;
  display: flex;
  flex-direction: column;
  gap: 0;
}
.ap-line {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: var(--cf-radius, 8px);
  padding: 10px 12px;
  margin-bottom: 8px;
  background: var(--cf-bg, #f4f6f8);
}
.ap-line__info {
  flex: 1;
  min-width: 0;
}
.ap-line__product {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--cf-text, #1a1d23);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ap-line__meta {
  font-size: 0.775rem;
  color: var(--cf-text-muted, #6b7280);
  margin-top: 2px;
}
.ap-line__total {
  font-size: 0.9rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--cf-text, #1a1d23);
  white-space: nowrap;
  min-width: 64px;
  text-align: right;
}
.ap-line__actions {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
}
.ap-icon-btn {
  width: 32px;
  height: 32px;
}
.ap-icon-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.ap-icon-btn--edit {
  color: var(--cf-text-muted, #6b7280) !important;
}
.ap-icon-btn--edit:hover {
  color: var(--cf-brand-dark, #4d7a00) !important;
}
.ap-icon-btn--delete {
  color: var(--cf-text-muted, #6b7280) !important;
}
.ap-icon-btn--delete:hover {
  color: var(--cf-error, #dc2626) !important;
}
.ap-line-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  padding: 4px 0 8px;
}
.ap-btn-add-line {
  font-size: 0.825rem !important;
  border-color: var(--cf-brand, #e3fd64) !important;
  color: var(--cf-brand-dark, #4d7a00) !important;
}
.ap-btn-add-line:hover {
  background: var(--cf-brand-light, #f9ffe0) !important;
}
.ap-totals {
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: var(--cf-radius, 8px);
  overflow: hidden;
  margin-top: 12px;
}
.ap-totals__row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 12px;
  font-size: 0.85rem;
  border-bottom: 1px solid var(--cf-border, #e5e7eb);
}
.ap-totals__row:last-child {
  border-bottom: none;
}
.ap-totals__row--final {
  background: var(--cf-bg, #f4f6f8);
}
.ap-totals__label {
  color: var(--cf-text-muted, #6b7280);
  font-weight: 500;
}
.ap-totals__value {
  font-variant-numeric: tabular-nums;
  color: var(--cf-text, #1a1d23);
}
.ap-totals__value--total {
  font-size: 1rem;
  color: var(--cf-brand-dark, #4d7a00);
}
.ap-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
  gap: 18px;
}
.ap-loading__icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: var(--cf-brand, #e3fd64);
  opacity: 0.6;
}
.ap-loading__text {
  margin: 0;
  font-size: 0.875rem;
  color: var(--cf-text-muted, #6b7280);
}
::ng-deep .ap-page .mat-mdc-form-field-subscript-wrapper {
  min-height: 0 !important;
}
::ng-deep .ap-page .mat-mdc-form-field-bottom-align::before {
  display: none !important;
}
/*# sourceMappingURL=advancePayment.component.css.map */
